'use strict';
// Shared pure preview logic; no network, Shopify cart, or payment operations.
(function (root) {
  const owns = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  function validRefs(refs, catalog, allowEmpty = false) {
    return Array.isArray(refs) && refs.length >= (allowEmpty ? 0 : 1) && refs.length <= 3
      && refs.every(ref => typeof ref === 'string' && owns(catalog, ref));
  }
  function quote(refs, catalog, offers) {
    if (!validRefs(refs, catalog)) throw new Error('Choose one, two, or three valid designs.');
    const subtotalCents = refs.reduce((sum, ref) => sum + catalog[ref].unitCents, 0);
    const discountCents = offers.discountCents[refs.length];
    const netCents = subtotalCents - discountCents;
    const shippingCents = offers.shippingCents[refs.length];
    if (![subtotalCents, discountCents, netCents, shippingCents].every(n => Number.isSafeInteger(n) && n >= 0)) {
      throw new Error('The archived offer is invalid.');
    }
    // Integer-cent allocation so repeated and mixed line totals always reconcile.
    const eachDiscount = Math.floor(discountCents / refs.length);
    const remainder = discountCents % refs.length;
    const lines = [];
    refs.forEach((ref, index) => {
      let line = lines.find(item => item.reference === ref);
      if (!line) { line = {reference: ref, quantity: 0, totalCents: 0}; lines.push(line); }
      line.quantity++;
      line.totalCents += catalog[ref].unitCents - eachDiscount - (index < remainder ? 1 : 0);
    });
    return {count: refs.length, subtotalCents, discountCents, netCents, shippingCents,
      preTaxTotalCents: netCents + shippingCents, taxCents: null,
      percent: Math.floor(discountCents * 1000 / subtotalCents) / 10, lines};
  }
  function dailyClock(milliseconds) {
    const seconds = Math.floor(milliseconds / 1000);
    const remaining = 86400 - ((seconds % 86400 + 86400) % 86400);
    const display = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60]
      .map(part => String(part).padStart(2, '0')).join(':');
    return {display, end: new Date((seconds + remaining) * 1000).toISOString()};
  }
  function liveHref(refs, catalog, liveStore) {
    if (!validRefs(refs, catalog)) throw new Error('Cannot transfer invalid selections.');
    const target = new URL(liveStore);
    if (target.protocol !== 'https:' || target.hostname !== 'liftmischief.transcendtech.org'
      || target.username || target.password || target.port) throw new Error('Unexpected live store.');
    target.pathname = '/'; target.search = ''; target.hash = 'lm-builder';
    target.searchParams.set('page', 'home');
    refs.forEach(ref => target.searchParams.append('face', ref));
    return target.href;
  }
  function initialSelection(search, catalog, saved, productRef) {
    const params = new URLSearchParams(search), faces = params.getAll('face');
    if (faces.length) return {refs: validRefs(faces, catalog) ? faces : null, source: 'link'};
    if (productRef) return {refs: owns(catalog, productRef) ? [productRef, productRef] : null, source: 'product'};
    if (validRefs(saved, catalog)) return {refs: [...saved], source: 'saved'};
    const first = Object.keys(catalog)[0];
    const count = ['1', '2', '3'].includes(params.get('crew')) ? Number(params.get('crew')) : 2;
    return {refs: Array(count).fill(first), source: 'default'};
  }
  const model = {validRefs, quote, dailyClock, liveHref, initialSelection};
  root.LMCopyModel = model;
  if (typeof module !== 'undefined' && module.exports) module.exports = model;
})(typeof globalThis !== 'undefined' ? globalThis : this);
